import { useTranslation } from 'react-i18next';
import {
  SectionWrapper,
  StyledHr,
  ContentWrapper,
  TextBox1,
  TextBox2,
  SectionContainer,
} from './AuditFour.style';

const AuditFour = () => {
  const { t } = useTranslation('audit');
  return (
    <SectionContainer>
      <SectionWrapper>
        <h1>{t('auditFour.title')}</h1>
        <StyledHr />
      </SectionWrapper>

      <ContentWrapper>
        <p>
          {t('auditFour.subtitle.spanBefore')}
          <span>2</span>
          {t('auditFour.subtitle.spanAfter')}
        </p>
        <TextBox1>
          <TextBox2>
            <h2>{t('auditFour.subtitleTwo')}</h2>
            <p>{t('auditFour.paragraphOne')}</p>
          </TextBox2>

          <TextBox2>
            <h2>{t('auditFour.subtitleThree')}</h2>
            <p>{t('auditFour.paragraphTwo')}</p>
          </TextBox2>

          <TextBox2>
            <h2>{t('auditFour.subtitleFour')}</h2>
            <p>
              {t('auditFour.paragraphThree.spanBefore')}
              <span>2</span> {t('auditFour.paragraphThree.spanAfter')}
              <span>2</span>.
            </p>
          </TextBox2>
        </TextBox1>
      </ContentWrapper>
    </SectionContainer>
  );
};

export default AuditFour;
